import { GDTApiErrors } from '@/types';
import type {
  FormData,
  InviteUserByIdResponse,
  RequestParamsInvitarAmigo,
  ResponseAccionPostLogin,
  ResponseInvitarAmigo,
  ResponseSugerirUsuariosGCA,
  SearchDtsResponse,
  TournamentInviteFormData,
} from '@/types/invites';
import { URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const inviteToTournament = axiosErrorHandler(
  async (data: TournamentInviteFormData) => {
    const params = new URLSearchParams({
      _action: 'invitarAmigosTDA',
      idTDA: data.idTDA.toString(),
      nombre: data.names.join('|'),
      mail: data.emails.join('|'),
    });

    const url = `${URLs.TORNEO_INVITAR_EMAIL}?${params.toString()}`;

    const response = await axiosGdt.get<ResponseInvitarAmigo | GDTApiErrors>(
      url
    );

    return response.data;
  }
);

export const inviteFriendGdt = axiosErrorHandler(async (data: FormData) => {
  const reqParams: RequestParamsInvitarAmigo = {
    emailUsuarioInvitado: encodeURI(data.email),
    nombreUsuarioInvitado: encodeURIComponent(data.name),
  };

  const url = URLs.INVITAR_AMIGO;
  const response = await axiosGdt.post<ResponseInvitarAmigo | GDTApiErrors>(
    url,
    reqParams,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return response.data;
});

export const searchDtsByName = axiosErrorHandler(
  async (search: string, idTDA: number) => {
    const params = new URLSearchParams({
      search,
      idTDA: idTDA.toString(),
    });

    const url = `${URLs.BUSCAR_DTS}?${params.toString()}`;

    const response = await axiosGdt.get<SearchDtsResponse | GDTApiErrors>(url);

    return response.data;
  }
);

export const inviteUserById = axiosErrorHandler(
  async (idTorneo: number, idUsuarioDT: number) => {
    const params = new URLSearchParams({
      _action: 'invitarDTSATDA',
      idTorneo: idTorneo.toString(),
      idUsuarioDT: idUsuarioDT.toString(),
    });

    const url = `${URLs.TORNEO_AMIGOS.INVITAR_POR_ID}?${params.toString()}`;

    const response = await axiosGdt.get<InviteUserByIdResponse | GDTApiErrors>(
      url
    );

    return response.data;
  }
);

export const suggestUsersToInvite = axiosErrorHandler(
  async (cantMaxResultados = 3) => {
    const params = new URLSearchParams({
      _action: 'sugerirUsuariosML', // Agregar el parámetro _action
      cantMaxResultados: cantMaxResultados.toString(), // Parámetro cantMaxResultados
    });

    const url = `${URLs.SUGERIR_USUARIOS}?${params.toString()}`;

    const response = await axiosGdt.get<
      ResponseSugerirUsuariosGCA | GDTApiErrors
    >(url);

    return response.data;
  }
);

export const invitacionesTkred = axiosErrorHandler(async (tkRed: string) => {
  const params = new URLSearchParams({
    tkRed,
  });
  const url = `${URLs.MINILIGAS.INVITAR_TKRED}`;
  const response = await axiosGdt.get<ResponseAccionPostLogin | GDTApiErrors>(
    url,
    { params }
  );
  return response.data;
});
